<main class="content">
  <section class="welcome" aria-labelledby="home-title">
    <h1 id="home-title" class="page-title">RetireRight</h1>
    <p class="home-description">
      Manage application decommissioning and archival assessments. <br /><br />
      Use RetireRight to submit new demands, track the status of your demands,
      and complete actions assigned to you during the decommissioning and
      archival lifecycle.
    </p>
  </section>

  <section class="home-actions" aria-label="RetireRight actions">
    @for (action of actions; track action.route) {
      <div class="home-action" [attr.data-route]="action.route">
        <div class="row">
          <span class="action-copy">
            <h2>{{ action.title }}</h2>
            <p>{{ action.description }}</p>
          </span>
          <mat-icon fontSet="material-symbols-outlined">{{ action.icon }}</mat-icon>
        </div>

        <a
          class="btn btn-outline home-action-link"
          [routerLink]="action.route"
          [attr.aria-label]="'Open ' + action.title"
        >
          <span>{{ action.actionText }}</span>
        </a>
      </div>
    }
  </section>
</main>
